import * as csv from "csvtojson";
import { AccountMovement, parseDatevLine, RawExtfLine } from "../db/AccountMovement";

export interface FileMeta {
  fileName: string;
}
type cb = (row: AccountMovement, meta: FileMeta & { lineNumber: number }) => void;

function readFile(file: File): Promise<string> {
  console.log("Beginning Upload of File:", file.name);
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = () => {
      console.log("Upload complete:", file.name);
      resolve(fr.result!.toString());
    };
    fr.onabort = reject;
    fr.onerror = reject;
    fr.readAsBinaryString(file);
  });
}

export default class ExtfLoader {
  public static async readFile(f: File, callback: cb) {
    const meta = {
      fileName: f.name
    };
    const rawContent = await readFile(f);
    const endFirstLine = rawContent.search(/\r\n/);
    console.log("Datev-Header read:", rawContent.substr(0, endFirstLine));

    console.log("Beginning processing of file:", f.name);
    await csv({
      delimiter: ";",
      flatKeys: true,
      includeColumns: /Buchungstext|Umsatz|Kennzeichen|Konto|Gegenkonto|Belegdatum|KOST1/
    })
      .subscribe((data: RawExtfLine, lineNumber: number) => {
        // console.log(f.name, "line:", lineNumber);
        return callback(parseDatevLine(data), {
          ...meta,
          lineNumber: lineNumber + 2
        });
      })
      .fromString(rawContent.substr(endFirstLine + 2));
    console.log("Completed processing of file:", f.name);

    return meta;
  }
}



// WEBPACK FOOTER //
// ./src/app/ExtfLoader.ts